import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
// config
import { defaultLang } from "../config";
//
import enLocales from "./en";
import analyticsEn from "./english/analytics";
import { askDostEn } from "./english/askDostEn";
import { taxesEn } from "./english/catalog/taxes";
import { currencyEn } from "./english/catalog/currency";
import { paymentMethodEn } from "./english/catalog/paymentMethod";
import { paymentTermEn } from "./english/catalog/paymentTerm";
import codingTemplateEn from "./english/codingTemplate";
import { companiesEn } from "./english/companiesEn";
import configurationLandingEn from "./english/configurationLanding";
import desigualEn from "./english/desigual";
import dimensionEn from "./english/dimension";
import { discrepanciesEn } from "./english/discrepancies";
import discrepancyEn from "./english/discrepancy";
import discrepancyStandardizationEn from "./english/discrepancyStandardization";
import stagesEn from "./english/stages";
import postingDatePolicyEn from "./english/postingDatePolicy";
import peppolPartyRegistrationEn from "./english/peppolPartyRegistration";
import extractionConfigurationEn from "./english/extractionConfiguration";
import validationConfigurationEn from "./english/validationConfiguration";
import { documentConfigurationEn } from "./english/documentConfiguration";
import documentReviewV2En from "./english/documentReviewV2";
import documentsEn from "./english/documents";
import dynamicMessagesEn from "./english/dynamicMessages";
import { emailInboxEn } from "./english/emailInboxEn";
import { employeeEn } from "./english/expense/employee";
import { expensesEn } from "./english/expense/expenses";
import exportConfigurationEn from "./english/exportConfiguration";
import globalEn from "./english/global";
import integrationEn from "./english/integration";
import legalDocumentsEn from "./english/legalDocuments";
import { manualDocumentEn } from "./english/manualDocument";
import mappingsEn from "./english/mappings";
import notesEn from "./english/notes";
import onboardingTemplateEn from "./english/onboardingTemplate";
import { bankReconciliationEn } from "./english/payments/bankReconciliation";
import consildatedCashFlow from "./english/payments/consildatedCashFlow";
import makePaymentsEn from "./english/payments/makePayments";
import paymentConfigEn from "./english/payments/paymentConfig";
import transactionCountReportEn from "./english/payments/transactionCountReport";
import postProcessorConfigurationEn from "./english/postProcessorConfig";
import customerPayment from "./english/reports/customerPayment";
import selfTrainingReportEn from "./english/reports/selfTraining";
import { workflowReport } from "./english/reports/workflow";
import { roleDialogFeatureEn } from "./english/role/roleDialogFeature";
import selfTrainingV2En from "./english/selfTrainingV2";
import supplierEn from "./english/suppliers";
import tasksEn from "./english/tasks";
import transactionsEn from "./english/transactions";
import vlmInstructons from "./english/vlmInstructons";
import voloteaEn from "./english/volotea";
import webhookEn from "./english/webhook";
import workflowsEn from "./english/workflows";
import workflowTemplatesEn from "./english/workflowTemplates";
import esLocales from "./es";
import analyticsEs from "./spanish/analytics";
import { askDostEs } from "./spanish/askDostEs";
import { taxesEs } from "./spanish/catalog/taxes";
import { currencyEs } from "./spanish/catalog/currency";
import { paymentMethodEs } from "./spanish/catalog/paymentMethod";
import { paymentTermEs } from "./spanish/catalog/paymentTerm";
import codingTemplateEs from "./spanish/codingTemplate";
import { companiesEs } from "./spanish/companiesEs";
import configurationLandingEs from "./spanish/configurationLanding";
import desigualEs from "./spanish/desigual";
import dimensionEs from "./spanish/dimension";
import { discrepanciesEs } from "./spanish/discrepancies";
import discrepancyEs from "./spanish/discrepancy";
import discrepancyStandardizationEs from "./spanish/discrepancyStandardization";
import peppolPartyRegistrationEs from "./spanish/peppolPartyRegistration";
import extractionConfigurationEs from "./spanish/extractionConfiguration";
import validationConfigurationEs from "./spanish/validationConfiguration";
import { documentConfigurationEs } from "./spanish/documentConfiguration";
import documentReviewV2Es from "./spanish/documentReviewV2";
import documentsEs from "./spanish/documents";
import dynamicMessagesEs from "./spanish/dynamicMessages";
import { emailInboxEs } from "./spanish/emailInboxEs";
import { employeeEs } from "./spanish/expense/employee";
import { expensesEs } from "./spanish/expense/expenses";
import exportConfigurationEs from "./spanish/exportConfiguration";
import globalEs from "./spanish/global";
import integrationEs from "./spanish/integration";
import legalDocumentsEs from "./spanish/legalDocuments";
import { manualDocumentEs } from "./spanish/manualDocument";
import mappingsEs from "./spanish/mappings";
import notesEs from "./spanish/notes";
import onboardingTemplateEs from "./spanish/onboardingTemplate";
import { bankReconciliationEs } from "./spanish/payments/bankReconciliation";
import consildatedCashFlowES from "./spanish/payments/consildatedCashFlow";
import makePaymentsEs from "./spanish/payments/makePayments";
import paymentConfigEs from "./spanish/payments/paymentConfig";
import transactionCountReportEs from "./spanish/payments/transactionCountReport";
import postingDatePolicyEs from "./spanish/postingDatePolicy";
import postProcessorConfigurationEs from "./spanish/postProcessorConfig";
import customerPaymentES from "./spanish/reports/customerPayment";
import selfTrainingReportEs from "./spanish/reports/selfTraining";
import { workflowReport as workflowReportES } from "./spanish/reports/workflow";
import { roleDialogFeatureEs } from "./spanish/role/roleDialogFeature";
import selfTrainingV2Es from "./spanish/selfTrainingV2";
import stagesEs from "./spanish/stages";
import supplierEs from "./spanish/suppliers";
import tasksEs from "./spanish/tasks";
import transactionsEs from "./spanish/transactions";
import vlmInstructonsEs from "./spanish/vlmInstructions";
import voloteaEs from "./spanish/volotea";
import webhookEs from "./spanish/webhook";
import workflowsEs from "./spanish/workflows";
import workflowTemplatesEs from "./spanish/workflowTemplates";

// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations: {
          ...enLocales,
          ...globalEn,
          ...manualDocumentEn,
          ...documentReviewV2En,
          ...configurationLandingEn,
        },
        integration_screen: { ...integrationEn },
        workflow_screen: { ...workflowsEn },
        mapping_screen: { ...mappingsEn },
        exportConfiguration_screen: { ...exportConfigurationEn },
        transaction_screen: { ...transactionsEn },
        reports: {
          ...workflowReport,
          ...customerPayment,
        },
        documents_screen: { ...documentsEn },
        dynamicMessages: { ...dynamicMessagesEn },
        supplier_screen: { ...supplierEn },
        discrepancy_screen: {
          ...discrepancyEn,
        },
        discrepancy_standardization_screen: {
          ...discrepancyStandardizationEn,
        },
        self_training_report_screen: { ...selfTrainingReportEn },
        notes_screen: { ...notesEn },
        analytics: { ...analyticsEn },
        discrepancies: { ...discrepanciesEn },
        roles: { ...roleDialogFeatureEn },
        payments: {
          ...bankReconciliationEn,
          ...makePaymentsEn,
          ...paymentConfigEn,
          ...consildatedCashFlow,
          ...transactionCountReportEn,
        },
        volotea_screen: {
          ...voloteaEn,
        },
        desigual_screen: {
          ...desigualEn,
        },
        employee_screen: {
          ...employeeEn,
        },
        expense_screen: {
          ...expensesEn,
        },
        taxes_screen: {
          ...taxesEn,
        },
        currency_screen: { ...currencyEn },
        payment_method_screen: { ...paymentMethodEn },
        payment_term_screen: { ...paymentTermEn },
        document_configuration_screen: {
          ...documentConfigurationEn,
        },
        manual_document_screen: {
          ...manualDocumentEn,
        },
        vlmInstructons: {
          ...vlmInstructons,
        },
        self_training_v2: {
          ...selfTrainingV2En,
        },
        post_processor_configuration: { ...postProcessorConfigurationEn },
        companies_screen: { ...companiesEn },
        email_inbox: { ...emailInboxEn },
        legal_documents_screen: { ...legalDocumentsEn },
        ask_dost_screen: { ...askDostEn },
        dimension_screen: { ...dimensionEn },
        stages_screen: { ...stagesEn },
        coding_template_screen: { ...codingTemplateEn },
        posting_date_policy_screen: { ...postingDatePolicyEn },
        peppol_party_registration_screen: { ...peppolPartyRegistrationEn },
        extraction_configuration_screen: { ...extractionConfigurationEn },
        validation_configuration_screen: { ...validationConfigurationEn },
        webhook_screen: { ...webhookEn },
        onboarding_template_screen: { ...onboardingTemplateEn },
        workflowTemplates: { ...workflowTemplatesEn },
        tasks_screen: { ...tasksEn },
      },
      es: {
        translations: {
          ...esLocales,
          ...globalEs,
          ...manualDocumentEs,
          ...documentReviewV2Es,
          ...configurationLandingEs,
        },
        integration_screen: { ...integrationEs },
        workflow_screen: { ...workflowsEs },
        mapping_screen: { ...mappingsEs },
        exportConfiguration_screen: { ...exportConfigurationEs },
        transaction_screen: { ...transactionsEs },
        reports: {
          ...workflowReportES,
          ...customerPaymentES,
        },
        documents_screen: { ...documentsEs },
        dynamicMessages: { ...dynamicMessagesEs },
        supplier_screen: { ...supplierEs },
        discrepancy_screen: {
          ...discrepancyEs,
        },
        discrepancy_standardization_screen: {
          ...discrepancyStandardizationEs,
        },
        self_training_report_screen: { ...selfTrainingReportEs },
        notes_screen: { ...notesEs },
        analytics: { ...analyticsEs },
        discrepancies: { ...discrepanciesEs },
        roles: { ...roleDialogFeatureEs },
        payments: {
          ...bankReconciliationEs,
          ...makePaymentsEs,
          ...paymentConfigEs,
          ...consildatedCashFlowES,
          ...transactionCountReportEs,
        },
        volotea_screen: {
          ...voloteaEs,
        },
        desigual_screen: {
          ...desigualEs,
        },
        employee_screen: {
          ...employeeEs,
        },
        expense_screen: {
          ...expensesEs,
        },
        taxes_screen: {
          ...taxesEs,
        },
        currency_screen: { ...currencyEs },
        payment_method_screen: { ...paymentMethodEs },
        payment_term_screen: { ...paymentTermEs },
        document_configuration_screen: {
          ...documentConfigurationEs,
        },
        manual_document_screen: {
          ...manualDocumentEs,
        },
        vlmInstructons: {
          ...vlmInstructonsEs,
        },
        self_training_v2: {
          ...selfTrainingV2Es,
        },
        post_processor_configuration: { ...postProcessorConfigurationEs },
        companies_screen: { ...companiesEs },
        email_inbox: { ...emailInboxEs },
        legal_documents_screen: { ...legalDocumentsEs },
        ask_dost_screen: { ...askDostEs },
        dimension_screen: { ...dimensionEs },
        stages_screen: { ...stagesEs },
        coding_template_screen: { ...codingTemplateEs },
        posting_date_policy_screen: { ...postingDatePolicyEs },
        peppol_party_registration_screen: { ...peppolPartyRegistrationEs },
        extraction_configuration_screen: { ...extractionConfigurationEs },
        validation_configuration_screen: { ...validationConfigurationEs },
        webhook_screen: { ...webhookEs },
        onboarding_template_screen: { ...onboardingTemplateEs },
        workflowTemplates: { ...workflowTemplatesEs },
        tasks_screen: { ...tasksEs },
      },
    },
    lng: localStorage.getItem("i18nextLng") || defaultLang.value,
    fallbackLng: "es",
    debug: false,
    fallbackNS: ["translations", "manual_document_screen"],
    ns: [
      "translations",
      "integration_screen",
      "workflow_screen",
      "mapping_screen",
      "exportConfiguration_screen",
      "transaction_screen",
      "reports",
      "supplier_screen",
      "discrepancy_screen",
      "discrepancy_standardization_screen",
      "self_training_report_screen",
      "notes_screen",
      "analytics",
      "payments",
      "discrepancies",
      "roles",
      "volotea_screen",
      "desigual_screen",
      "employee_screen",
      "expense_screen",
      "taxes_screen",
      "currency_screen",
      "payment_method_screen",
      "payment_term_screen",
      "manual_document_screen",
      "self_training_v2",
      "post_processor_configuration",
      "legal_documents_screen",
      "dimension_screen",
      "stages_screen",
      "coding_template_screen",
      "posting_date_policy_screen",
      "validation_configuration_screen",
      "webhook_screen",
      "onboarding_template_screen",
      "workflowTemplates",
      "tasks_screen",
    ],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
